// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"3ce0adc2","990":"15f3dad3"}[chunkId] + ".chunk.js";
};